export const SET_APP_READY = 'app/SET_APP_READY'
export const SUBMIT_CONTACT_US_FORM = 'app/SUBMIT_CONTACT_US_FORM'
